<template>
  <b-card-code title="Form User">
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button variant="primary" :to="{ name: 'user-add' }">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">Add User</span>
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary">
                <span class="text-nowrap">Search</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col cols="12">
            <b-col sm="12" class="my-2 mr-4">
              <b-table-simple striped hover style="font-size:80%">
                <b-thead>
                  <b-tr>
                    <b-th>User</b-th>
                    <b-th>Role</b-th>
                    <b-th>Email</b-th>
                    <b-th>NoHP</b-th>
                    <b-th>Tanggal Diterima</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="item in users" :key="item.id">
                    <b-td class="align-middle" style="width:10%">
                      {{ item.nomorDO }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.jenisPengiriman }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.namaProduk }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.tujuanKirim }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.jumlahVial }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.tanggalPengiriman | longDate }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.tanggalDiterima | longDate }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col></b-col
          >
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Total {{ nomorBatchTotal }} </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="nomorBatchTotal"
              :per-page="pageSize"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="getDataBatch"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code';
import { mapGetters } from 'vuex';

export default {
  components: {
    BCardCode,
  },
  data() {
    return {
      total: 10,
      currentPage: 1,
      perPage: 1,
      totalUsers: 1,
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('user', ['users']),
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      this.$store.dispatch('user/getUser');
    },
  },
};
</script>
